<template>
    <div class="py-4">
        <modal-filter v-if="onfilter" :onfilter="onfilter" :filter="filter" @onclose="onfilter = false"
            @onfilter="ONFILTER()" :exclude="[]" />
        <modal-delete v-if="ondelete" :ondelete="ondelete" :id="id" @onclose="ondelete = false"
            @onreload="ONFILTER()" />
        <modal-deliver v-if="ondeliver" :ondeliver="ondeliver" :id="id" @onclose="ondeliver = false"
            @onreload="ONFILTER()" />
        <header>
            <div class="container-fluid">
                <div class="pb-4">
                    <div class="row align-items-end">
                        <div class="col-sm col-12">
                            <h1 class="h2 ls-tight">Paquetería</h1>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main>
            <div class="container-fluid">
                <div class="vstack gap-4">
                    <div class="d-flex flex-column flex-md-row gap-3 justify-content-between">
                        <form class="d-flex gap-3 row" @submit.prevent="FILTER()">
                            <div>
                                <button @click="onfilter = true" type="button" class="btn btn-h px-3 btn-neutral">
                                    <i class="bi bi-funnel me-2"></i>
                                    <span>Filtro</span>
                                    <span class="vr opacity-20 mx-3"></span>
                                    <span class="text-xs text-primary">{{ count_filter }}</span>
                                </button>
                            </div>
                            <div>
                                <button @click="SORT()" type="button" class="btn btn-h px-3 btn-neutral">
                                    <i class="me-2"
                                        :class="filter.sortDesc == 'ASC' ? 'bi bi-sort-alpha-up' : 'bi bi-sort-alpha-down-alt'"></i>
                                    <span>{{ filter.sortDesc }}</span>
                                </button>
                            </div>
                            <div class="col-md-4 px-0">
                                <div class="input-group input-group-sm input-group-inline">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text pe-2 text-sm"><i class="bi bi-search"></i></span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="Buscar..."
                                        v-model="filter.search">
                                </div>
                            </div>
                            <div>
                                <button type="submit" class="btn btn-h px-3 btn-primary">
                                    <div class="spinner-border spinner-border-sm" role="status"
                                        v-if="loading == 'filter'">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Buscar</span>
                                </button>
                            </div>
                            <div>
                                <button type="button" class="btn btn-h px-3 btn-danger" @click="CLEAR()">
                                    <div class="spinner-border spinner-border-sm" role="status"
                                        v-if="loading == 'clear'">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Limpiar</span>
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card">
                        <div class="card-header bg-white">
                            <h5 class="me-auto">Listado</h5>
                        </div>
                        <div class="card-body p-0">
                            <template>
                                <v-data-table class="elevation-1" :headers="headers"
                                    :items="loading == 'table' || loading == 'sort' || loading == 'filter' || loading == 'clear' ? [] : items.data"
                                    show-expand :single-expand="true" :expanded.sync="expanded" :options.sync="options"
                                    @item-expanded="loadDetails" :server-items-length="items.total"
                                    :loading="loading == 'table' || loading == 'sort' || loading == 'filter' || loading == 'clear'"
                                    :footer-props="{
                                        'items-per-page-options': [5, 10, 50, 100]
                                    }">
                                    <template v-slot:[`item.id`]="{ item }">
                                        {{
                                            items.to >= 10 ? items.to - options.itemsPerPage + items.data.indexOf(item) +
                                                1 : items.data.indexOf(item) + 1
                                        }}
                                    </template>
                                    <template v-slot:[`item.id`]="{ item }">
                                        <router-link :to="{ name: 'PackageDetail', params: { id: item.id } }"
                                            class="text-decoration-none">
                                            {{ item.type }}{{ item.id }}
                                        </router-link>
                                    </template>
                                    <template v-slot:[`item.state_id`]="{ item }">
                                        <span class="badge badge-pill" v-if="CHECK_STATE(item.state_id)"
                                            :class="CHECK_STATE(item.state_id).labels">{{
                                                CHECK_STATE(item.state_id).name }}</span>
                                    </template>
                                    <template v-slot:[`item.payment`]="{ item }">
                                        <span class="badge badge-pill"
                                            v-if="item.invoice_amount && CHECK_STATEP(item.invoice_amount.state_id)"
                                            :class="CHECK_STATEP(item.invoice_amount.state_id).labels">{{
                                                CHECK_STATEP(item.invoice_amount.state_id).name }}</span>
                                    </template>
                                    <template v-slot:[`item.deliver`]="{ item }">
                                        <v-tooltip top
                                            v-if="globalViewOption('PackageDeliver') && item.invoice_amount && item.invoice_amount.state_id == 22">
                                            <template v-slot:activator="{ on, attrs }">
                                                <a v-bind="attrs" v-on="on">
                                                    <button @click="DELIVER(item.id)" type="button"
                                                        class="btn btn-success btn-m">
                                                        <small><i class="bi bi-currency-dollar"></i></small>
                                                    </button>
                                                </a>
                                            </template>
                                            <small>Entregar paquete</small>
                                        </v-tooltip>
                                        <button class="btn btn-success btn-m" disabled v-else>
                                            <small><i class="bi bi-currency-dollar"></i></small>
                                        </button>
                                    </template>
                                    <template v-slot:[`item.is_fel`]="{ item }">
                                        <v-tooltip top
                                            v-if="globalViewOption('PackageFel') && item.invoice_amount && item.invoice_amount.state_id || globalViewOption('PackageFel') && item.is_fel">
                                            <template v-slot:activator="{ on, attrs }">
                                                <a v-bind="attrs" v-on="on">
                                                    <router-link :to="{ name: 'PackageFel', params: { id: item.id } }"
                                                        class="btn btn-info btn-m">
                                                        <small><i class="bi bi-receipt"></i></small>
                                                    </router-link>
                                                </a>
                                            </template>
                                            <small>Factura electrónica</small>
                                        </v-tooltip>
                                        <button class="btn btn-info btn-m" disabled v-else>
                                            <small><i class="bi bi-receipt"></i></small>
                                        </button>
                                    </template>
                                    <template v-slot:[`item.update`]="{ item }">
                                        <v-tooltip top v-if="globalViewOption('PackageUpdate') && item.state_id != 17">
                                            <template v-slot:activator="{ on, attrs }">
                                                <a v-bind="attrs" v-on="on">
                                                    <router-link
                                                        :to="{ name: 'PackageUpdate', params: { id: item.id } }"
                                                        class="btn btn-primary btn-m">
                                                        <small><i class="bi bi-pencil-square"></i></small>
                                                    </router-link>
                                                </a>
                                            </template>
                                            <small>Editar</small>
                                        </v-tooltip>
                                        <button class="btn btn-primary btn-m" disabled v-else>
                                            <small><i class="bi bi-pencil-square"></i></small>
                                        </button>
                                    </template>
                                    <template v-slot:[`item.delete`]="{ item }">
                                        <v-tooltip top v-if="globalViewOption('PackageDelete') && item.state_id != 17">
                                            <template v-slot:activator="{ on, attrs }">
                                                <button @click="DELETE(item.id)" type="button" v-bind="attrs" v-on="on"
                                                    class="btn btn-danger btn-m">
                                                    <small><i class="bi bi-trash3"></i></small>
                                                </button>
                                            </template>
                                            <small>Eliminar</small>
                                        </v-tooltip>
                                        <button class="btn btn-danger btn-m" disabled v-else>
                                            <small><i class="bi bi-trash3"></i></small>
                                        </button>
                                    </template>
                                    <template v-slot:[`item.invoice_amount`]="{ item }">
                                        <button v-if="!item.invoice_amount" type="button" disabled
                                            class="btn btn-outline-dark btn-m">
                                            <small><i class="bi bi-file-earmark-font"></i></small>
                                        </button>
                                        <v-tooltip top v-else>
                                            <template v-slot:activator="{ on, attrs }">
                                                <button type="button" @click="PRINT_INVOICE(item.id)" v-bind="attrs"
                                                    v-on="on" class="btn btn-success btn-h px-3">
                                                    <small class="d-flex align-items-center justify-content-center"><i
                                                            class="fa-solid fa-dollar mr-1"></i> {{
                                                                Number(item.invoice_amount.total || 0).toFixed(2)
                                                            }}</small>
                                                </button>
                                            </template>
                                            <small>Factura</small>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:expanded-item="{ headers, item }">
                                        <td colspan="100%">
                                            <table class="table table-borderless table-sm mt-2 mb-5">
                                                <thead class="bg-white">
                                                    <tr style="color: rgba(0,0,0,.6);">
                                                        <th class="text-start sortable"
                                                            style="font-size: .75rem; border-bottom: thin solid rgba(0,0,0,.12);">
                                                            Descripción</th>
                                                        <th class="text-start sortable"
                                                            style="font-size: .75rem; border-bottom: thin solid rgba(0,0,0,.12);">
                                                            Valor Declarado</th>
                                                        <th class="text-start sortable"
                                                            style="font-size: .75rem; border-bottom: thin solid rgba(0,0,0,.12);">
                                                            Tracking</th>
                                                        <th class="text-start sortable"
                                                            style="font-size: .75rem; border-bottom: thin solid rgba(0,0,0,.12);">
                                                            AWB</th>
                                                        <th class="text-start sortable"
                                                            style="font-size: .75rem; border-bottom: thin solid rgba(0,0,0,.12);">
                                                            Creado</th>
                                                        <th class="text-start sortable"
                                                            style="font-size: .75rem; border-bottom: thin solid rgba(0,0,0,.12);">
                                                            Actualizado</th>
                                                        <th class="text-start sortable"
                                                            style="font-size: .75rem; border-bottom: thin solid rgba(0,0,0,.12);">
                                                            Ruta</th>
                                                        <th class="text-start sortable"
                                                            style="font-size: .75rem; border-bottom: thin solid rgba(0,0,0,.12);">
                                                            Sucursal</th>
                                                        <th class="text-start sortable"
                                                            style="font-size: .75rem; border-bottom: thin solid rgba(0,0,0,.12);">
                                                            Inventario</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr style="color: rgba(0,0,0,.6);">
                                                        <td class="text-start sortable"
                                                            style="font-size: .75rem; border-bottom: thin solid rgba(0,0,0,.12);">
                                                            <v-tooltip bottom class="mx-1">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <div v-bind="attrs" v-on="on" class="nowrap"
                                                                        v-if="Array.isArray(item.description)">
                                                                        {{ item.description[0] }} ...
                                                                    </div>
                                                                </template>
                                                                <small>
                                                                    <div v-for="(description, key) in item.description"
                                                                        :key="key">{{ description }}</div>
                                                                </small>
                                                            </v-tooltip>
                                                        </td>
                                                        <td class="text-start sortable"
                                                            style="font-size: .75rem; border-bottom: thin solid rgba(0,0,0,.12);">
                                                            $ {{ Number(item.value || 0).toFixed(2) }}</td>
                                                        <td class="text-start sortable"
                                                            style="font-size: .75rem; border-bottom: thin solid rgba(0,0,0,.12);">
                                                            {{ item.tracking }}</td>
                                                        <td class="text-start sortable"
                                                            style="font-size: .75rem; border-bottom: thin solid rgba(0,0,0,.12);">
                                                            <div class="spinner-border spinner-border-sm mb-0"
                                                                v-if="typeof (item.is_expanded) === 'undefined' && item.awb_id !== null"
                                                                role="status">
                                                                <span class="sr-only">Loading...</span>
                                                            </div>
                                                            <div v-else>
                                                                {{
                                                                    item.awb ? item.awb.awb + (item.hawb ? ' - ' +
                                                                        item.hawb.hawb : '') : ''
                                                                }}
                                                            </div>
                                                        </td>
                                                        <td class="text-start sortable"
                                                            style="font-size: .75rem; border-bottom: thin solid rgba(0,0,0,.12);">
                                                            {{ item.created_at | DATETIME }}</td>
                                                        <td class="text-start sortable"
                                                            style="font-size: .75rem; border-bottom: thin solid rgba(0,0,0,.12);">
                                                            {{ item.updated_at | DATETIME }}</td>
                                                        <td class="text-start sortable"
                                                            style="font-size: .75rem; border-bottom: thin solid rgba(0,0,0,.12);">
                                                            <div class="spinner-border spinner-border-sm mb-0"
                                                                role="status"
                                                                v-if="typeof(item.is_expanded) === 'undefined' && typeof(item.deliver_route) !== 'undefined'">
                                                                <span class="sr-only">Loading...</span>
                                                            </div>
                                                            <div v-else>
                                                                {{
                                                                    item.deliver_route ? (item.deliver_route.route ?
                                                                        (item.deliver_route.id + ' - ' +
                                                                            item.deliver_route.route.full_name) : '') : ''
                                                                }}
                                                            </div>
                                                        </td>
                                                        <td class="text-start sortable"
                                                            style="font-size: .75rem; border-bottom: thin solid rgba(0,0,0,.12);">
                                                            <div class="spinner-border spinner-border-sm mb-0"
                                                                v-if="typeof (item.is_expanded) === 'undefined' && item.branch_office_id !== null"
                                                                role="status">
                                                                <span class="sr-only">Loading...</span>
                                                            </div>
                                                            <div v-else>
                                                                {{ item.branch_office ? item.branch_office.name : '' }}
                                                            </div>
                                                        </td>
                                                        <td class="text-start sortable"
                                                            style="font-size: .75rem; border-bottom: thin solid rgba(0,0,0,.12);">
                                                            <i class="fas"
                                                                :class="item.in_stock ? 'fa-check' : 'fa-close'"></i>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <tfoot>
                                                    <td colspan="100%" class="text-center">
                                                        <router-link
                                                            :to="{ name: 'PackageDetail', params: { id: item.id } }"
                                                            class="text-decoration-none text-center sortable"
                                                            style="font-size: .75rem;">
                                                            Más detalles...
                                                        </router-link>
                                                    </td>
                                                </tfoot>
                                            </table>
                                        </td>
                                    </template>
                                </v-data-table>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import ModalFilter from './modals/Filter'
import ModalDelete from './modals/Delete'
import ModalDeliver from './modals/Deliver'
export default {
    components: { ModalFilter, ModalDelete, ModalDeliver },
    data() {
        return {
            headers: [
                { text: 'GVT', value: 'id', sortable: false },
                { text: 'Cliente', value: 'user.name', sortable: false },
                { text: 'Estado', value: 'state_id', sortable: false },
                { text: 'Pago', value: 'payment', sortable: false },
                { text: 'Pagar', value: 'deliver', sortable: false },
                { text: 'FEL', value: 'is_fel', sortable: false },
                { text: 'Editar', value: 'update', sortable: false },
                { text: 'Borrar', value: 'delete', sortable: false },
                { text: 'Factura', value: 'invoice_amount', sortable: false },
                { text: 'Más', value: 'data-table-expand', sortable: false }
            ],
            items: {
                data: [],
                total: 0,
                to: 0
            },
            loading: '',
            cancelToken: null,
            expanded: [],
            options: {},
            filter: {
                operator: '==',
                sortBy: 'id',
                sortDesc: 'DESC',
                fields: ['id'],
                search: '',
                loading: '',
                state_id: [],
                payment_state_id: []
            },
            onfilter: false,
            ondelete: false,
            ondeliver: false,
            states: [],
            id: null,
            count: 0,
            payment_states: [],
        }
    },
    computed: {
        count_filter: function () {
            let count = 0;
            let vue = this
            Object.entries(vue.filter).forEach((e) => {
                if (e[0] != 'sortBy' && e[0] != 'sortDesc' && e[0] != 'search' && e[0] != 'loading') {
                    if (typeof e[1] == 'object') {
                        if (e[1]) {
                            if (e[1].length > 0) {
                                count++
                            }
                        }
                    } else {
                        if (e[1]) {
                            count++
                        }
                    }
                }
            })
            return count;
        }
    },
    created() {
        this.STATES()
        this.PAYMENT_STATES()
    },
    methods: {
        loadDetails: function (e) {
            let vue = this
            if (e.value === false) {
                return
            }
            let index = this.items.data.findIndex((a) => a.id == e.item.id)
            let is_expanded = typeof (e.item.is_expanded) !== 'undefined' ? e.item.is_expanded : false
            let awb = typeof (e.item.awb_id) !== 'undefined' ? e.item.awb_id : null
            let hawb = typeof (e.item.hawb_id) !== 'undefined' ? e.item.hawb_id : null
            let branch_office = typeof (e.item.branch_office_id) !== 'undefined' ? e.item.branch_office_id : null
            if (is_expanded === true) {
                return
            } else {
                if (awb !== null || hawb !== null || branch_office !== null) {
                    axios({ url: '/packages/' + e.item.id + '/expanded', method: 'GET' })
                        .then((resp) => {
                            let data = resp.data
                            vue.items.data.splice(index, 1, Object.assign({}, data, e.item))
                        })
                }
            }
        },
        STATES: function () {
            let vue = this
            axios({ url: '/all/states', method: 'GET' })
                .then((resp) => {
                    vue.states = resp.data
                })
        },
        PAYMENT_STATES: function () {
            let vue = this
            axios({ url: '/all/payment/states', method: 'GET' })
                .then((resp) => {
                    vue.payment_states = resp.data
                })
        },
        INIT: function () {
            let vue = this
            const source = axios.CancelToken.source()
            vue.cancelToken = source
            const { page, itemsPerPage } = vue.options
            let query = {
                page: page,
                itemsPerPage: itemsPerPage,
            }
            Object.entries(vue.filter).forEach((e) => {
                query[e[0]] = e[1]
            })
            axios({
                url: '/packages',
                method: 'GET',
                params: query,
                cancelToken: source.token,
            })
                .then((resp) => {
                    vue.items = resp.data
                    vue.loading = ''
                })
                .catch((err) => {
                    if (err.code !== 'ERR_CANCELED') {
                        if (err.response.status === 402) {
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                        vue.loading = ''
                    }
                })
        },
        SORT: function () {
            let vue = this
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.filter.sortDesc = vue.filter.sortDesc == 'ASC' ? 'DESC' : 'ASC'
            vue.loading = 'sort'
            vue.INIT()
        },
        ONFILTER: function () {
            let vue = this
            vue.onfilter = false
            vue.loading = 'table'
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.INIT()
        },
        FILTER: function () {
            let vue = this
            let count = 0
            if (vue.filter.search.length > 0) {
                count++
            }
            if (count > 0) {
                vue.loading = 'filter'
                if (vue.cancelToken) {
                    vue.cancelToken.cancel("Solicitud cancelada");
                }
                vue.INIT()
            }
        },
        CLEAR: function () {
            let vue = this
            vue.loading = 'clear'
            vue.filter = {
                operator: '==',
                sortBy: 'id',
                sortDesc: 'DESC',
                fields: ['id'],
                search: '',
                loading: '',
                state_id: [],
                payment_state_id: []
            }
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.INIT()
        },
        DELETE: function (id) {
            let vue = this
            vue.id = id
            vue.ondelete = true
        },
        DELIVER: function (id) {
            let vue = this
            vue.id = id
            vue.ondeliver = true
        },
        PRINT_INVOICE: function (id) {
            let vue = this
            const routeData = vue.$router.resolve({ name: 'PackageInvoice', params: { id: id } })
            window.open(routeData.href, '_blank')
        },
        CHECK_STATE: function (id) {
            let vue = this
            let state = vue.states.find((e) => { return e.id == id });
            if (state) {
                state.labels = state.labels ? state.labels : 'badge-light'
            }
            return state
        },
        CHECK_STATEP: function (id) {
            let vue = this
            let state = vue.payment_states.find((e) => { return e.id == id });
            if (state) {
                state.labels = state.labels ? state.labels : 'badge-light'
            }
            return state
        },
    },
    watch: {
        options: {
            handler() {
                if (this.cancelToken) {
                    this.cancelToken.cancel("Solicitud cancelada");
                }
                this.loading = 'table'
                this.INIT()
            },
            deep: true
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/packages/Index.vue